import { msg } from "@lingui/core/macro";
import { createRoute } from "@tanstack/solid-router";
import { ShieldCheck } from "@fleet/icons";
import { appRoute } from "./route";
import { PageContainer } from "@fleet/ui/page-container";
import { PageHeader } from "@fleet/ui/page-header";
import { CongregationConfig } from "@/features/settings/components/congregation-config";
import { useI18n } from "@/providers/i18n-provider";

function CongregationSettingsPage() {
  const { t } = useI18n();
  return (
    <PageContainer maxWidth="4xl" class="space-y-8">
      <PageHeader
        title={t(msg`Congregation settings`)}
        description={t(
          msg`Meeting, inventory, retention and privacy defaults for your congregation.`,
        )}
        backTo="/profile"
        icon={ShieldCheck}
      />
      <CongregationConfig />
    </PageContainer>
  );
}

export const profileCongregationSettingsRoute = createRoute({
  getParentRoute: () => appRoute,
  path: "/profile/congregation-settings",
  component: CongregationSettingsPage,
});
